const advance = {
  path: 'advance',
  component: resolve => require(['../../../pages/enroll/advance'], resolve)
}

export default advance
